import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  private emailapiUrl:any = `${environment.travel}`;
  private inventory:any = `${environment.inventory}`;


  constructor(
    private _http: HttpClient
  ) { }

  sendQuote(quoteId:string, data:any, type:any):Observable<any>{
    return this._http.post(`${this.emailapiUrl}/sendquote/${quoteId}/${type}`, data);
  }

  sendVoucher(voucherId:string, data:any):Observable<any>{
    return this._http.post(`${this.emailapiUrl}/sendvoucher/${voucherId}`, data);
  }

  sendInvoice(invoiceId:string, data:any, showServiceAmount: any = true):Observable<any>{
    return this._http.post(`${this.emailapiUrl}/sendinvoice/${invoiceId}?showServiceAmount=${showServiceAmount}`, data);
  }

  sendVendorDmc(data:any):Observable<any>{
    return this._http.post(`${this.emailapiUrl}/vendordmcs/sendvendordmcemail`,data);
  }

  sendItinerary(ItineraryId:string, data:any,htmlcontent:any):Observable<any>{
    var body={
      fromEmail:data.fromEmail,
      toemails:data.toEmails,
      htmlbody:htmlcontent
    }
    return this._http.post(`${this.inventory}/senditinerary/${ItineraryId}`, body);
  }

  sendVisaCheckList(countryId:string, data:any,htmlcontent:any):Observable<any>{
    var body={
      fromEmail:data.fromEmail,
      toemails:data.toEmails,
      htmlbody:htmlcontent
    }
    return this._http.post(`${this.inventory}/sendvisachecklist/${countryId}`, body);
  }
}
